import React, { useState } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
} from "@mui/material";
import CommonButton from "../../Components/InputComponents/CommonButton";
import SelectInput from "../../Components/InputComponents/SelectInput";

const modules = [
  "Admin",
  "Client",
  "Candidate",
  "Staff",
  "Job",
  "Recruitment Procedure",
  "Recruitment Procedure Mapping",
  "Document Checklist",
  "Lookups",
];
const privileges = ["Add", "Edit", "View", "Delete"];

export default function RolePrivilegeUI() {
  const [selectedRole, setSelectedRole] = React.useState("");
  const [privilegeState, setPrivilegeState] = React.useState(
    modules.reduce((acc, module) => {
      acc[module] = privileges.reduce((pAcc, p) => {
        pAcc[p] = false;
        return pAcc;
      }, {});
      return acc;
    }, {})
  );

  const handleChange = (module, privilege) => {
    setPrivilegeState((prev) => ({
      ...prev,
      [module]: {
        ...prev[module],
        [privilege]: !prev[module][privilege],
      },
    }));
  };

  const handleModuleSelectAll = (module) => {
    const allChecked = privileges.every((priv) => privilegeState[module][priv]);
    setPrivilegeState((prev) => ({
      ...prev,
      [module]: privileges.reduce((pAcc, priv) => {
        pAcc[priv] = !allChecked;
        return pAcc;
      }, {}),
    }));
  };

  const isModuleAllChecked = (module) => {
    return privileges.every((priv) => privilegeState[module][priv]);
  };

  const handleSubmit = () => {
    alert("saved privilages");
  };

  return (
    <Box sx={{ p:4}}>
      <Grid container>
        <Grid item xs={12} sm={3} mb={3}>
          {/* <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Select a Role
          </Typography> */}
          <SelectInput
            value={selectedRole}
            options={[
              { value: "admin", label: "Admin" },
              { value: "client", label: "Client" },
              { value: "candidate", label: "Candidate" },
            ]}
            onChange={(e) => {
              setSelectedRole(e.target.value);
            }}
            placeholder="Select a Role"
          />
        </Grid>
      </Grid>

      <Grid container spacing={5}>
        {modules.map((module) => (
          <Grid
            item
            xs={12}
            md={6}
            key={module}
            sx={{ transition: "0.5s ease-in-out" }}
          >
            <Paper
              sx={{
                p: 3,
                boxShadow: "none",
                border: "2px solid transparent",
                boxShadow: "0px 0px 10px 0px lightgrey",
                borderRadius: "10px",
              }}
            >
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{
                  fontFamily: "Geist, sans-serif",
                  mb: 1,
                  background: "white",
                  display: "inline-block",
                }}
              >
                {module}
              </Typography>

              <FormGroup row>
                {privileges.map((priv) => (
                  <FormControlLabel
                    key={priv}
                    control={
                      <Checkbox
                        checked={privilegeState[module][priv]}
                        onChange={() => handleChange(module, priv)}
                        sx={{ transform: "scale(1.2)", padding: "15px" }}
                      />
                    }
                    label={priv}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontFamily: "Geist, sans-serif",
                        fontWeight: "500",
                      },
                    }}
                  />
                ))}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isModuleAllChecked(module)}
                      onChange={() => handleModuleSelectAll(module)}
                      sx={{ transform: "scale(1.2)", padding: "15px" }}
                    />
                  }
                  label="Select All"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontFamily: "Geist, sans-serif",
                      fontWeight: "500",
                    },
                  }}
                />
              </FormGroup>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
          >
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Box>
  );
}
